// IMPORTANT: Please remember to update this file whenever a new feature flag is added.
// Add the new feature flag as a constant by defining it here and include it in the featureFlags array below.
// Also, make sure to remove any feature flags from this file that are no longer being used in the code.

export const MILESTONE_IMPROVED_SIGNUP_ENABLED = 'MILESTONE_IMPROVED_SIGNUP_ENABLED';
export const MILESTONE_ONE_FEED_ENABLED = 'MILESTONE_ONE_FEED_ENABLED';
export const MILESTONE_USERS_PROVIDE_BOARD_ID_AND_DOB_ENABLED = 'MILESTONE_USERS_PROVIDE_BOARD_ID_AND_DOB_ENABLED';
export const MILESTONE_FIRST_SUBSCRIPTION_EXPIRES_ENABLED = 'MILESTONE_FIRST_SUBSCRIPTION_EXPIRES_ENABLED';
export const REFACTOR_LAYOUT_ENABLED = 'REFACTOR_LAYOUT_ENABLED';
export const MILESTONE_MIGRATE_SR_COURSES_TO_PREMIUM_ENABLED = 'MILESTONE_MIGRATE_SR_COURSES_TO_PREMIUM_ENABLED';
export const MILESTONE_PLANS_UPDATES_PART_ONE_ENABLED = 'MILESTONE_PLANS_UPDATES_PART_ONE_ENABLED';
export const MILESTONE_FREE_AND_LIFETIME_UPDATES_V2_ENABLED = 'MILESTONE_FREE_AND_LIFETIME_UPDATES_V2_ENABLED';

// Migration of pages
export const MIGRATE_PAGE_MY_PLAN_ENABLED = 'MIGRATE_PAGE_MY_PLAN_ENABLED';

// Every feature flag should be added to this array, to be considered by the feature flag service.
export const FEATURE_FLAGS = [
  MILESTONE_IMPROVED_SIGNUP_ENABLED,
  MILESTONE_ONE_FEED_ENABLED,
  MILESTONE_USERS_PROVIDE_BOARD_ID_AND_DOB_ENABLED,
  MILESTONE_FIRST_SUBSCRIPTION_EXPIRES_ENABLED,
  REFACTOR_LAYOUT_ENABLED,
  MILESTONE_MIGRATE_SR_COURSES_TO_PREMIUM_ENABLED,
  MILESTONE_PLANS_UPDATES_PART_ONE_ENABLED,
  MILESTONE_FREE_AND_LIFETIME_UPDATES_V2_ENABLED,
];

// These feature flags are always off, regardless of the feature flag service status.
export const DISABLED_FEATURE_FLAGS = [
  MILESTONE_IMPROVED_SIGNUP_ENABLED,
  MILESTONE_ONE_FEED_ENABLED,
  MILESTONE_PLANS_UPDATES_PART_ONE_ENABLED,
  // Please enable the test qa/e2e/cypress/e2e/Subscriptions/Upgrade/LifetimeUpgrade.cy.js when enabling this feature flag
  MILESTONE_FREE_AND_LIFETIME_UPDATES_V2_ENABLED,
];

// These feature flags are always on, regardless of the feature flag service status.
export const ALWAYS_ON_FEATURE_FLAGS = [MIGRATE_PAGE_MY_PLAN_ENABLED];
